import React from 'react';

// Constants

// Components

// Styles
import '../_gradients.scss';

const GradientsDocs = () => {
  const gradients = ['blue', 'orange', 'orange-purple', 'purple', 'pink'] as const;

  return (
    <>
      {gradients.map(gradient => (
        <div
          className={`mb-2 gradient-${gradient}`}
          style={{
            width: '100%',
            height: '50px',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            padding: '8px',
          }}
        >
          {gradient}
        </div>
      ))}
    </>
  );
};

export default GradientsDocs;
